(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boski-email-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'boski-email-popup-dismissed';
    const now = Date.now();

    document.querySelectorAll('[data-bb-email-popup]').forEach((popup) => {
      if (!(popup instanceof HTMLDialogElement)) return;

      const baseDiscount = Number(popup.dataset.baseDiscount);
      const baseReference = Number(popup.dataset.baseReference);
      const localReferenceMinor = Number(popup.dataset.localReferenceMinor);
      const activeCurrency = popup.dataset.activeCurrency || 'PLN';
      const activeLocale = popup.dataset.locale || document.documentElement.lang || 'en';
      const canConvert =
        Number.isFinite(baseDiscount) &&
        Number.isFinite(baseReference) &&
        Number.isFinite(localReferenceMinor) &&
        baseDiscount > 0 &&
        baseReference > 0 &&
        localReferenceMinor > 0;

      if (canConvert) {
        const localDiscount = baseDiscount * (localReferenceMinor / 100) / baseReference;
        const formattedDiscount = new Intl.NumberFormat(activeLocale, {
          style: 'currency',
          currency: activeCurrency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(localDiscount);

        popup.querySelectorAll('[data-popup-amount]').forEach((amount) => {
          amount.textContent = formattedDiscount;
        });
      }

      const repeatDays = Number(popup.dataset.repeatDays || 14);
      const delay = Number(popup.dataset.delay || 12000);
      const success = popup.dataset.success === 'true';
      const lastDismissed = Number(window.localStorage.getItem(storageKey) || 0);
      const canShow = now - lastDismissed > repeatDays * 86400000;
      let opened = false;

      const openPopup = () => {
        if (opened || popup.open) return;
        opened = true;
        popup.showModal();
        const focusTarget = popup.querySelector('input, .bb-email-popup__shop, [data-popup-close]');
        if (focusTarget instanceof HTMLElement) focusTarget.focus();
      };

      const rememberDismissal = () => {
        window.localStorage.setItem(storageKey, String(Date.now()));
      };

      popup.querySelector('[data-popup-close]')?.addEventListener('click', () => {
        rememberDismissal();
        popup.close();
      });

      popup.addEventListener('cancel', rememberDismissal);

      popup.addEventListener('click', (event) => {
        if (event.target === popup) {
          rememberDismissal();
          popup.close();
        }
      });

      if (success) {
        rememberDismissal();
        openPopup();
        return;
      }

      if (!canShow) return;

      window.setTimeout(openPopup, delay);

      const handleScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && window.scrollY / scrollable >= 0.4) {
          openPopup();
          window.removeEventListener('scroll', handleScroll);
        }
      };

      window.addEventListener('scroll', handleScroll, { passive: true });

      document.addEventListener('mouseout', (event) => {
        if (
          event.clientY <= 0 &&
          event.relatedTarget === null &&
          window.matchMedia('(pointer: fine)').matches
        ) {
          openPopup();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
